import { render } from "./TheSubscriptionsProductDetails.vue?vue&type=template&id=32f7ba64"
import script from "./TheSubscriptionsProductDetails.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionsProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__